import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 23,
	viewBox: "0 0 24 23",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-500 -1584)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(500 1584)",
				fill: "#fff",
				stroke: "#bebebe",
				strokeWidth: 1,
				children: [/* @__PURE__ */ _jsx("ellipse", {
					cx: 12,
					cy: 11.5,
					rx: 12,
					ry: 11.5,
					stroke: "none"
				}), /* @__PURE__ */ _jsx("ellipse", {
					cx: 12,
					cy: 11.5,
					rx: 11.5,
					ry: 11,
					fill: "none"
				})]
			}),
			/* @__PURE__ */ _jsx("line", {
				x2: 11,
				transform: "translate(506.5 1595.5)",
				fill: "none",
				stroke: "#00488E",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("line", {
				x2: 11,
				transform: "translate(512 1590) rotate(90)",
				fill: "none",
				stroke: "#00488E",
				strokeWidth: 1
			})
		]
	})
});
export default SvgAddPlus;
